import { useEffect } from "react";

import type { UserDTO } from "../../common/types/UserDTO";
import type { VenueDTO } from "../../common/types/VenueDTO";

declare global {
  interface Window {
    pendo: any;
  }
}

export const usePendo = (user?: UserDTO, venue?: VenueDTO) => {
  useEffect(() => {
    if (user) {
      const { email, id, roles, properties, accountId, accountName } = user;
      const fullName =
        properties?.firstName && properties.lastName
          ? `${properties.firstName} ${properties.lastName}`
          : "";
      const venueId = properties?.selectedVenueId;
      window.pendo?.initialize({
        visitor: {
          email: email,
          id: id,
          fullName: fullName,
          firstName: properties?.firstName || "",
          language: properties?.locale || "",
          role: roles[0] || "",
          venueId: venueId || "",
          venueName: venue?.name || "",
        },
        account: {
          id: accountId,
          name: accountName,
        },
      });
    }
  }, [user, venue]);
};
